export default "__VITE_ASSET__wtT3t1tf__"